import React, { useEffect, useState } from "react";
import { NavigationContainer } from "@react-navigation/native";
import { createDrawerNavigator } from "@react-navigation/drawer";
import { createNativeStackNavigator } from "@react-navigation/native-stack";

import { linking } from "router/linking";
import { navigationRef } from "router/helper";
import { webPagesTitle } from "router/webPagesTitle";
import DrawerContent from "router/drawerContent";

import { Loading } from "component";
import Toast from "component/toast";
import HomeStack from "./stacks";

import { InsertMobile, VerifyCode } from "screen";

import { useRecoilValue } from "recoil";
import { useCart, useUser } from "client/api";
import { authAtom, storage } from "store";

import { colors, sizes } from "asset/constant";
import { sn } from "utils";

const Stack = createNativeStackNavigator<Routes>();
const Drawer = createDrawerNavigator<Routes>();

const Navigator = () => {
  const [initialLoading, setInitialLoading] = useState(true);
  const stopLoading = () => setInitialLoading(false);

  const auth = useRecoilValue(authAtom);

  const { refetch: refetchUser } = useUser();
  const { refetch: refetchCart } = useCart();

  useEffect(() => {
    storage.get().then((storedUser) => {
      if (storedUser?.token) {
        Promise.all([refetchUser(), refetchCart()]).then((res: any) => {
          if (res[0].status === "success" && res[1].status === "success") {
            setTimeout(stopLoading, 2000);
            return;
          } else {
            if (res[0]?.error?.response?.status === 401) {
              setTimeout(stopLoading, 2000);
              return;
            }
          }
        });
      } else {
        stopLoading();
      }
    });
  }, []);

  if (initialLoading) {
    return <Loading />;
  }

  return (
    <NavigationContainer linking={linking} ref={navigationRef}>
      {auth?.token ? (
        <Drawer.Navigator
          drawerContent={DrawerContent}
          screenOptions={() => {
            return {
              sceneContainerStyle: { backgroundColor: colors.bg.screen },
              headerShown: false,
              swipeEnabled: false,
              drawerType: sn("front", "front", "front", "permanent"),
              drawerPosition: "right",
              drawerStyle: {
                width: sizes.drawerW,
                borderLeftWidth: 0.5,
                borderLeftColor: colors.black + "11",
              },
            };
          }}
        >
          <Drawer.Screen name="wholesaler" component={HomeStack} />
        </Drawer.Navigator>
      ) : (
        <Stack.Navigator screenOptions={{ headerShown: false }}>
          <Stack.Screen
            name={"insert_mobile"}
            component={InsertMobile}
            options={{ title: webPagesTitle.insert_mobile }}
          />
          <Stack.Screen
            name={"verify_code"}
            component={VerifyCode}
            options={{ title: webPagesTitle.verify_code }}
          />
        </Stack.Navigator>
      )}
      <Toast.Provider />
    </NavigationContainer>
  );
};

export default Navigator;
